import { ThemeConfig } from "antd";

export const theme: ThemeConfig = {
  token: {
    colorPrimary: "#ff9f1c",
    colorTextBase: "#000",
    fontFamily: "Inter",
  },
  components: {
    Layout: {
      siderBg: "#fdf9f3",
      bodyBg: "#fdf9f3",
      headerBg: "#fdf9f3",
      headerPadding: "0 16px",
    },
    Menu: {
      itemActiveBg: "#fff",
      itemSelectedBg: "#fff",
      itemBg: "#fdf9f3",
      itemSelectedColor: "#000",
      padding: 0,
      activeBarBorderWidth: 3,
    },
    Button: {
      primaryColor: "#000",
      colorLink: "#000",
      colorLinkHover: "#000",
      paddingBlock: "10px",
      paddingInline: "20px",
      controlHeight: 44,
      fontWeight: 500,
      lineHeight: 20,
      fontFamily: "Inter",
    },
    Typography: {
      fontSize: 16,
      fontFamily: "Inter",
    },
    Form: {
      labelFontSize: 18,
      padding: 6,
      fontFamily: "Inter",
    },
    Select: {
      controlHeight: 50,
      fontSize: 18,
      fontFamily: "Inter",
    },
    Input: {
      controlHeight: 53,
      fontSize: 18,
      lineHeight: 1.5,
      fontFamily: "Inter",
    },
    InputNumber: {
      controlHeight: 53,
      fontSize: 18,
      lineHeight: 1.5,
      fontFamily: "Inter",
    },
    DatePicker: {
      controlHeight: 48,
      fontSize: 18,

      lineHeight: 1.5,
      fontFamily: "Inter",
    },
    Switch: {
      controlHeight: 12,
      colorPrimary: "#1D2023",
      handleSize: 8,
      trackHeight: 12,
      trackMinWidth: 24,
      innerMaxMargin: 12,
      fontFamily: "Inter",
    },
    Checkbox: {
      colorPrimary: "#1D2023",
      colorPrimaryHover: "#1D2023",
      fontSize: 16,
      fontFamily: "Inter",
    },
    Slider: {
      colorPrimary: "#1D2023",
      trackBg: "#1D2023",
      dotBorderColor: "#1D2023",
      dotActiveBorderColor: "#1D2023",
      handleActiveColor: "#1D2023",
      handleColor: "#1D2023",
      colorBgElevated: "#1D2023",
      trackHoverBg: "#1D2023",
      colorPrimaryBorderHover: "#1D2023",
      fontFamily: "Inter",
    },
    Tag: {
      fontSize: 12,
      borderRadiusSM: 20,
      colorBorder: "transparent",
      defaultBg: "#F5F5F5",
      fontFamily: "Inter",
    },
    Segmented: {
      borderRadius: 32,
      borderRadiusSM: 32,
      boxShadowTertiary: "",
      trackBg: "#EDE8DD",
      controlHeightLG: 64,
      controlPaddingHorizontal: 20,
      fontFamily: "Inter",
    },
    Avatar: {
      // groupBorderColor: "#ffac39",
      groupOverlapping: 0,
      fontFamily: "Inter",
    },
    Card: {
      borderRadiusLG: 16,
      fontFamily: "Inter",
    },
  },
};
